export default function Menu() {
  return <div>Dashboard</div>;
}